import { CommercialTripListConfiguration } from "../objects/commercialTripListConfiguration";
import { CommercialTripListCriteria } from "../objects/commercialTripListCriteria";
import { CommercialTripListFiltersCriteria } from "../objects/commercialTripListFiltersCriteria";
import { BEACHCOMBER_COLUMN, CDV_COLUMN, DEFAULT_COLUMN, MCI_COLUMN, MV_COLUMN } from "./tripColumn";

const subDomain = window.location.host.split('.')[0];
const domain = window.location.host.split('.')[1];
export const EMPTY_TRIP_LIST_CONFIGURATION: CommercialTripListConfiguration = {
    columns: domain === 'tripmci' ? MCI_COLUMN : subDomain === 'marcovasco' ? MV_COLUMN : subDomain === 'cercledesvoyages' || subDomain === 'continentsinsolites' ? CDV_COLUMN : subDomain === 'beachcomber' || subDomain === 'verdie-voyages' ? BEACHCOMBER_COLUMN : DEFAULT_COLUMN,
    preferences: []
};

export const EMPTY_TRIP_LIST_FILTERS: CommercialTripListFiltersCriteria = {
    creator: "",
    last_author: "",
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: "MODIFICATION",
    status: [],
    event: null,
    folder_type: 'ALL',
    folder_initiated_type: 'ALL',
    for_user: null,
    contact_traveler: '',
    pax: 0,
    destination: null,
    user_ta: null,
    user_to: null,
    target_client__in: []
};

export const EMPTY_TRIP_LIST_CRITERIA: CommercialTripListCriteria = {
    limit: 50,
    page: 0,
    order_by: '',
    order: 'asc',
    search: '',
    filters: EMPTY_TRIP_LIST_FILTERS
};